import type { AccountScopeUserSettings } from 'owa-service/lib/types/AccountScopeUserSettings';
import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
import assert from 'owa-assert/lib/assert';

export const updateAccountScopeUserSettings: (
    sourceId: string,
    updateFunction: (accountScopeUserSettings: AccountScopeUserSettings) => void
) => void = mutatorAction(
    'setAccountScopeUserSettings',
    (
        sourceId: string,
        updateFunction: (accountScopeUserSettings: AccountScopeUserSettings) => void
    ) => {
        const accountScopeUserSettings = getStore().accountScopeUserSettingsMap.get(sourceId);
        assert(!!accountScopeUserSettings);
        updateFunction(accountScopeUserSettings);
    }
);
